/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".edit-obstacle[_ngcontent-%COMP%]{margin-right:25px;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content}.edit-obstacle__button-spacing[_ngcontent-%COMP%]{margin-bottom:10px;margin-top:10px}.fieldset-container[_ngcontent-%COMP%]{margin-bottom:20px;padding-top:20px}"];
export { styles as styles };
